import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'

export const contactNumberField =({value, onChange}) => {
//   const [value, setValue] = useState()
  return (
    <PhoneInput
      placeholder="Enter phone number"
      value={value}
      onChange={onChange}
      ClassName="bg-yellow-300 w-full"
      />
  )
}